export const limitsEn = {};

export const limitsFr = {};
